import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCodeBookImportsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCodeBookImportsQuery = { __typename?: 'query_root', code_book_imports: Array<{ __typename?: 'code_book_imports', id: any, abbreviation: string, edition_year?: number | null, title: string, book_type: string, status: string, error_message?: string | null, page_count?: number | null, section_count?: number | null, printed_as_provision?: number | null, not_captured?: number | null, missing_parents?: number | null, figure_count?: number | null, commentary_family?: string | null, code_book_id?: any | null, published_at?: any | null, created_at: any, jurisdiction_record?: { __typename?: 'jurisdictions', id: any, name: string } | null }> };


export const GetCodeBookImportsDocument = gql`
    query getCodeBookImports {
  code_book_imports(order_by: {created_at: desc}) {
    id
    abbreviation
    edition_year
    title
    book_type
    status
    error_message
    page_count
    section_count
    printed_as_provision
    not_captured
    missing_parents
    figure_count
    commentary_family
    code_book_id
    published_at
    created_at
    jurisdiction_record {
      id
      name
    }
  }
}
    `;

/**
 * __useGetCodeBookImportsQuery__
 *
 * To run a query within a React component, call `useGetCodeBookImportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCodeBookImportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCodeBookImportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCodeBookImportsQuery(baseOptions?: Apollo.QueryHookOptions<GetCodeBookImportsQuery, GetCodeBookImportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCodeBookImportsQuery, GetCodeBookImportsQueryVariables>(GetCodeBookImportsDocument, options);
      }
export function useGetCodeBookImportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCodeBookImportsQuery, GetCodeBookImportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCodeBookImportsQuery, GetCodeBookImportsQueryVariables>(GetCodeBookImportsDocument, options);
        }
export function useGetCodeBookImportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCodeBookImportsQuery, GetCodeBookImportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCodeBookImportsQuery, GetCodeBookImportsQueryVariables>(GetCodeBookImportsDocument, options);
        }
export type GetCodeBookImportsQueryHookResult = ReturnType<typeof useGetCodeBookImportsQuery>;
export type GetCodeBookImportsLazyQueryHookResult = ReturnType<typeof useGetCodeBookImportsLazyQuery>;
export type GetCodeBookImportsSuspenseQueryHookResult = ReturnType<typeof useGetCodeBookImportsSuspenseQuery>;
export type GetCodeBookImportsQueryResult = Apollo.QueryResult<GetCodeBookImportsQuery, GetCodeBookImportsQueryVariables>;